export enum DataLineageModelProperties {
  ShowNodeDetails = 'ShowNodeDetails',
}
